import React from 'react';

import cx from 'classnames';
import { isNil } from 'ramda';

import styles from './index.module.css';

type Props = {
  children: React.ReactNode;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  noStyles?: boolean;
  popupLineShift?: string;
  popupLineName?: string;
  type?: 'default' | 'empty' | 'rounded';
};

function FormSection({
  children,
  id = '',
  className = '',
  style = undefined,
  noStyles = false,
  popupLineShift = '-4rem',
  popupLineName = 'popupLine',
  type = 'default',
}: Props) {
  if (isNil(children)) return null;

  return (
    <div
      className={
        noStyles
          ? className
          : cx(
              styles.section,
              {
                [styles.sectionEmpty]: type === 'empty',
                [styles.sectionRounded]: type === 'rounded',
              },
              className,
            )
      }
      style={style}
      id={id}
    >
      {children}
      <div
        className={popupLineName}
        style={{ position: 'absolute', height: '100%', top: '0', right: popupLineShift }}
      />
      <div
        className="controlledPopupLine"
        style={{ position: 'absolute', height: '100%', top: '0', right: popupLineShift }}
      />
    </div>
  );
}

export default FormSection;
